export default __webpack_public_path__ + "static/media/session8.6035ddb1.svg";